import styled, { css, keyframes } from 'styled-components';

import { SkeletonProps } from '.';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonWrapper = styled.div<SkeletonProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: ${({ borderRadius = '8px' }) => borderRadius};
  ${({ theme }) => css`
    background: linear-gradient(
      90deg,
      ${theme.neutral950} 25%,
      ${theme.neutral800} 50%,
      ${theme.neutral950} 75%
    );
  `}

  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;
